import Tester from "./Tester";

function RightBar({ workflow, version }) {
  return (
    <div className="mt-1 max-w-[400px]">
      <Tester />
    </div>
  );
}

export default RightBar;
